var $ = jQuery;
var main = {};
var win = $(window);
var doc = $(document);

main = {
  defaults: {
  },
  onInit: function() {
    var vm = this;

    console.log('main')

    vm.onSelectSize()
    vm.removePreselectedSize()
    vm.packSizeRedirect()
    vm.deselectColorSwatches()

    this.onResize()
  },
  onLoad: function(e) {
    var vm = this;

    setTimeout(function() {
      vm.preselectVariant()
    }, 1000)
  },
  onResize: function(e) {
    var vm = this;
  },
  showProductSizes: function() {
    const trigger = $('.quick-buy__trigger'),
          options = $('.quick-buy__size')

    doc.on('click', '.quick-buy__trigger', function() {
      $(this).next(options).slideToggle('fast')
      $(this).parent().toggleClass('expanded')
    })
  },


  onSelectSize: function() {
    var sizeOpt = $('.option-group__storrelse .variant-group__item')
    sizeOpt.click(function() {
      var value = $(this).attr('data-value')
      sizeOpt.removeClass('selected')
      $(`.option-group__storrelse .variant-group__item[data-value="${value}"]`).addClass('selected')

      console.log('value', value)
      $('.size-validation').hide()
      $('.option-group__storrelse .variant-group__variant').html(value)
    })
  },

  removePreselectedSize: function() {
    var hasVariant = window.location.search.indexOf('variant')
    if( $('body').hasClass('template-product') ) {
      if( hasVariant < 1 ) {
        $('.option-group__storrelse input')
          .attr('checked', false)
          .parent().removeClass('selected')
      } else {
        //variant-group__variant
        $('.option-group__storrelse .variant-group__variant').html($('.option-group__storrelse input:checked').val())
      }
    }
  },

  packSizeRedirect: function() {
    var variant = $('.variant-group__single label')
    variant.click(function() {
      var url = $(this).attr('data-url');
      var queryParams = '';
      var path = document.location.pathname.split('/');

      $('.variant-group__item input:checked').each(function(index, value) {
        var value = $(this).attr('data-title'), type = $(this).attr('data-option')
        var isLastElement = index == $('.variant-group__item input:checked').length -1;
        queryParams += (isLastElement) ? `${type}=${value}` : `${type}=${value}&` 
      })
      
      variant.removeClass('active')
      $(this).addClass('active')

      if( path[path.length - 1] != url ) {
        window.location.href= `${url}?${queryParams}`
      }

    })
  },

  preselectVariant: function() {

    if(document.location.search.length) {
    console.log('preselect variantss')
      var color = '', size = '';
      var urlParams = new URLSearchParams(window.location.search);
      var params = document.location.search

      if (params.indexOf("farve") >= 0) {
        color = urlParams.get('farve')
        $(`.variant-group__item input[data-title=${color}]`).trigger('click')
      } 
      
      if (params.indexOf("st%C3%B8rrelse") >= 0) {
        size = urlParams.get('størrelse')
        $(`.variant-group__item input[data-title=${size}]`).trigger('click')
        $(`.variant-group__item input[data-title=${size}]`).parent().addClass('selected')
      }

      console.log('color', color)
      console.log('size', size)
    }

  },

  deselectColorSwatches: function() {
    const card = $('.product-card');

    doc.on('mouseleave', '.product-card', function() {
      const _this = $(this);
      let sizes = _this.find('.size-options span'),
          swatches = _this.find('.swatch'),
          selectedColor = _this.find('.swatch:first-child').data('color-title'),
          productImg = _this.find('.variant-option__image:first-child'),
          altProductImg = _this.find('.variant-option__image:nth-child(2)'),
          optionImg = _this.find('.variant-option__color'),
          colors = _this.find('.swatch')
      
      /** Deselect color swatches */
      swatches.removeClass('selected')
      productImg.css('opacity', 1)
      optionImg.css('opacity', 0)
      altProductImg.removeAttr('style')
      
      colors.each(function() {
        var self = $(this)
        if( self.hasClass('preselected') ) {
          self.addClass('selected')
        }
      })

      /** Show the sizes of first color in Quick buy panel */
      if( !_this.find('.swatch.preselected').length ) {
        sizes.each(function() {
          var color = $(this).data('color')
          if( color == selectedColor ) {
            $(this).show()
          } else {
            $(this).hide()
          }
        })
      }

      /** Preselected variant image will show after mouseleave */
      main.displayActiveVariantImg({
        parent: _this,
        variant:  _this.data('active')
      })

    })
  },


};

doc.ready(function() {
  main.onInit();
});

win.on('load', function() {
  main.onLoad();
});

win.resize(function() {
  main.onResize();
});